import {actionType} from "./../actionType/actionType";

const initialState = {
  token: "",
  adminFrm: "",
  loading: false,
  authentication: false,
  logout: false,
  data: [],
  closeCheckIn: false,
  closeCheckOut: false,
};

export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.HANDLE_LOGIN: {
      return {
        ...state,
        handleLogin: true,
        data: [action.payload],
      };
    }
    case actionType.ACTION_FRM: {
      return {
        ...state,
        adminFrm: action.payload,
      };
    }
    case actionType.LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case actionType.HANDLE_AUTHENTICATION: {
      return {
        ...state,
        loading: action.payload.loading,
        authentication: action.payload.authentication,
        data: [action.payload.data],
        token: action.payload.token,
      };
    }
    case actionType.CLOSE_CHECKIN: {
      return {
        ...state,
        closeCheckIn: action.payload,
      };
    }
    case actionType.CLOSE_CHECKOUT: {
      return {
        ...state,
        closeCheckOut: action.payload,
      };
    }
    case actionType.LOGOUT:{
      return{
        ...state,
        authentication : action.payload
      }
    }
    default:
      return state;
  }
};
